module.exports = __webpack_public_path__ + "static/media/walmart.778dc375.svg";